import { Component } from 'react'
import QuotaBar from 'components/shared/QuotaBar'
import { getColor, getSeatColor } from 'components/GlobalNotificationBar/helpers'

require('./style.styl')

const CounterPane = ({ highlightColor, title, description, percentage }) => (
    <div className="counter-card">
      <div className="counter-card-label">
        <div style={{ color: highlightColor }}>{title}</div>
        <div className="description">{description}</div>
      </div>
      <QuotaBar percent={percentage} />
    </div>
)

export default class AccountStatusPane extends Component {

  renderCounters() {
    const { counters } = this.props
    const { type } = counters
    return _.map(counters, (counter) => <CounterPane {...counter} highlightColor={ type === 'seats' ? getSeatColor(counter.percentage) : getColor(counter.percentage)} />)
  }

  render() {
    const { planTitle, planDescription } = this.props
    return (
      <div className="counter-container">
        <div className="plan-card">
          <div className="title truncate" title={planTitle}>{planTitle}</div>
          <div className="description">{planDescription}</div>
        </div>
        {this.renderCounters()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalNotificationBar/components/AccountStatusPane/index.js